import request from '@/api/request'

export function listSysLog(data) {
  let req = {
    opType: data.opType,
    successFlag: data.successFlag,
    channel: data.channel,
    userId: data.userId,
    startTime: data.startTime,
    endTime: data.endTime,
    pageNum: data.pageNum,
    pageSize: data.pageSize
  }
  return request({
    url: 'webapi/sysLog/list',
    method: 'post',
    data: req,
  })
}
